import dayjs from 'dayjs'

const state = () => ({
  exams: null,
  deleted: null,
  exam: null,
  baseline: null,
  grid: null,
  compartments: null,
  reports: [
    {
      slug: 'history',
      title: 'History report',
      name: 'history',
      json: [
        {
          items: [
            {
              component: 'ReportHeader',
            },
          ],
        },
        {
          items: [
            {
              component: 'History',
            },
          ],
        },
        {
          items: [
            {
              component: 'ReportFooter',
            },
          ],
        },
      ],
    },
    {
      slug: 'comparison',
      title: 'Comparison report',
      name: 'comparison',
      json: [
        {
          items: [
            {
              component: 'ReportHeader',
            },
          ],
        },
        {
          items: [
            {
              component: 'Comparison',
            },
          ],
        },
        {
          items: [
            {
              component: 'ReportFooter',
            },
          ],
        },
      ],
    },
    {
      slug: 'comparison-pie',
      title: 'Comparison pie report',
      name: 'comparisonPie',
      json: [
        {
          items: [
            {
              component: 'ReportHeader',
            },
          ],
        },
        {
          items: [
            {
              component: 'ComparisonPie',
            },
          ],
        },
        {
          items: [
            {
              component: 'ReportFooter',
            },
          ],
        },
      ],
    },
    {
      slug: 'raw',
      title: 'Raw data report',
      name: 'raw',
      json: [
        {
          items: [
            {
              component: 'ReportHeader',
            },
          ],
        },
        {
          items: [
            {
              component: 'Raw',
            },
          ],
        },
        {
          items: [
            {
              component: 'ReportFooter',
            },
          ],
        },
      ],
    },
    {
      slug: 'rehab',
      title: 'Rehab report',
      name: 'rehab',
      json: [
        {
          items: [
            {
              component: 'ReportHeader',
            },
          ],
        },
        {
          items: [
            {
              component: 'Rehab',
            },
          ],
        },
        {
          items: [
            {
              component: 'ReportFooter',
            },
          ],
        },
      ],
    },
  ],
  report: null,
})

const getters = {
  exams: (state) => state.exams,
  deleted: (state) => state.deleted,
  exam: (state) => state.exam,
  baseline: (state) => state.baseline,
  grid: (state) => state.grid,
  report: (state) => state.report,
  compartments: (state) => state.compartments,
  selectedCompartment: (state) => {
    if (state.compartments) {
      const selectedCompartment = state.compartments.find(
        (item) => item.selected
      )
      return selectedCompartment ? selectedCompartment.name : null
    } else {
      return null
    }
  },
}

const mutations = {
  receiveExams(state, exams) {
    state.exams = exams
  },
  receiveDeleted(state, exams) {
    state.deleted = exams
  },
  receiveExam(state, exam) {
    state.exam = exam
  },
  receiveBaseline(state, exam) {
    state.baseline = exam
  },
  receiveGrid(state, exams) {
    state.grid = exams
  },
  receiveReport(state, report) {
    state.report = report
  },
  receiveCompartments(state, compartments) {
    state.compartments = compartments
  },
  toggleSelectedCompartment(state, itemId) {
    state.compartments.forEach((item) => {
      if (item.id === itemId) {
        item.selected = !item.selected
      } else {
        item.selected = false
      }
    })
  },
}

const actions = {
  getExams({ commit, rootState }, patientId) {
    return this.$axios
      .post('/bodyscan-backend/v1/app/exams/list', {
        accessToken: rootState.user.token,
        patientId,
      })
      .then((response) => {
        const exams = response.data.exams
        if (exams.length) {
          exams.forEach((exam) => {
            exam.dateTime = dayjs(exam.effectiveAt).format('L LT')
          })
          const baseline = exams.splice(
            exams.indexOf(exams.find((exam) => exam.isBaseline)),
            1
          )
          exams.unshift(...baseline)
        }
        commit('receiveExams', exams)
      })
  },
  getGrid({ commit, rootState }, patientId) {
    return this.$axios
      .post('/bodyscan-backend/v1/app/grid/view', {
        accessToken: rootState.user.token,
        patientId,
        limit: -1,
      })
      .then((response) => {
        const exams = response.data.exams
        if (exams.length) {
          const baseline = exams.splice(
            exams.indexOf(exams.find((exam) => exam.isBaseline)),
            1
          )
          exams.unshift(...baseline)
        }
        commit('receiveGrid', exams)
      })
  },
  getDeleted({ commit, rootState }, patientId) {
    return this.$axios
      .post('/bodyscan-backend/v1/app/exams/list', {
        accessToken: rootState.user.token,
        patientId,
        filter: {
          deleted: true,
        },
      })
      .then((response) => {
        const exams = response.data.exams
        if (exams.length) {
          exams.forEach((item) => {
            item.dateTime = dayjs(item.createdAt).format('L LT')
          })
        }
        commit('receiveDeleted', exams)
      })
  },
  restoreExam({ dispatch, rootState, rootGetters }, examId) {
    return this.$axios.post('/bodyscan-backend/v1/app/exams/restore', {
      accessToken: rootState.user.token,
      id: examId,
    })
  },
  getExam({ commit, dispatch, rootState }, examId) {
    return this.$axios
      .post('/bodyscan-backend/v1/app/exams/get', {
        accessToken: rootState.user.token,
        id: examId,
      })
      .then((response) => {
        const exam = response.data.exam
        return dispatch('patient/getPatient', exam.patientId, {
          root: true,
        }).then(() => {
          exam.patient = rootState.patient.patient
          commit('receiveExam', exam)
          const compartments = Object.keys(exam.compartments).map(
            (key, index) => {
              return {
                id: index,
                name: key,
                selected: false,
                ...exam.compartments[key],
              }
            }
          )
          commit('receiveCompartments', compartments)
        })
      })
  },
  getBaseline({ commit, rootState }, patientId) {
    return this.$axios
      .post('/bodyscan-backend/v1/app/baseline/get', {
        accessToken: rootState.user.token,
        patientId,
      })
      .then((response) => {
        commit('receiveBaseline', response.data.exam)
      })
  },
  setBaseline({ dispatch, rootState }, exam) {
    return this.$axios
      .post('/bodyscan-backend/v1/app/baseline/set', {
        accessToken: rootState.user.token,
        examId: exam.id,
      })
      .then(() => {
        dispatch('getExams', exam.patientId)
      })
  },
  createExam({ dispatch, rootState, rootGetters }, exam) {
    return this.$axios
      .post('/bodyscan-backend/v1/app/exams/create', {
        accessToken: rootState.user.token,
        exam,
      })
      .then(() => {
        dispatch('getExams', exam.patientId)
      })
  },
  updateExam({ dispatch, rootState, rootGetters }, exam) {
    return this.$axios
      .post('/bodyscan-backend/v1/app/exams/update', {
        accessToken: rootState.user.token,
        id: exam.id,
        exam,
      })
      .then(() => {
        dispatch('getExam', exam.id)
      })
  },
  deleteExam({ rootState, rootGetters }, examId) {
    return this.$axios.post('/bodyscan-backend/v1/app/exams/delete', {
      accessToken: rootState.user.token,
      id: examId,
    })
  },
  getReport({ state, commit }, reportSlug) {
    const report = state.reports.find((report) => report.slug === reportSlug)
    commit('receiveReport', report)
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true,
}
